export default "__VITE_ASSET__CTKSgWfd__"